import { createApp } from 'vue';
import App from './pages/App.vue';
import router from './router';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './utils/GlobalImport';

import Notifications from '@kyvg/vue3-notification';

// Bundleじゃないとpopperがはいっていないので、ドロップダウンなどが効かなくなる
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { SessionUser } from './utils/SessionUser';

window.onerror = (message, file, line) => {
  // MessageDialog.systemError('不明な箇所', '[システムエラー]', `が発生しました line ${line} file ${file} message ${message} ${SessionUser.toString()}`);
  console.error(
    '不明な箇所',
    '[システムエラー]',
    `が発生しました line ${line} file ${file} message ${message} ${SessionUser.toString()}`
  );
};

export const vue = createApp(App);
vue.use(router);
vue.use(Notifications);
export const mounted = vue.mount('#app');
